
import { useState, useEffect } from 'react';

export default function StickyCtaBar() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      setIsVisible(scrollY > 300); // Show after scrolling 300px
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleCallClick = () => {
    window.location.href = 'tel:+18003328373';
  };

  const handleChatClick = () => {
    const widget = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
    if (widget) {
      widget.click();
    }
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t-2 border-teal-600 shadow-lg z-40 transition-transform duration-300">
      <div className="max-w-6xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex-1">
            <div className="text-sm font-semibold text-gray-900">Ready to Get Out of Debt?</div>
            <div className="text-xs text-gray-600">Free consultation • No upfront fees • A+ BBB rated</div>
          </div>
          
          <div className="flex space-x-3">
            <button
              onClick={handleCallClick}
              className="flex items-center space-x-2 bg-teal-600 text-white px-4 py-2 rounded-md font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap"
            >
              <i className="fas fa-phone text-sm"></i>
              <span className="hidden sm:inline">Call Now</span>
              <span className="sm:hidden">Call</span>
            </button>
            
            <button
              onClick={handleChatClick}
              className="flex items-center space-x-2 bg-gray-800 text-white px-4 py-2 rounded-md font-semibold hover:bg-gray-900 transition-colors whitespace-nowrap"
            >
              <i className="fas fa-comments text-sm"></i>
              <span className="hidden sm:inline">Free Chat</span>
              <span className="sm:hidden">Chat</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
